import "rxjs/add/operator/map";
import { Component } from '@angular/core';
import { NavParams, NavController, Events } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { Observable} from 'rxjs/Observable';
@Component({
  selector: 'event-news',
  templateUrl: 'event-news.html'
})
export class EventNewsComponent {

  obs: any;
  obsNew: any;
  obsRelatedNews: any;
  obsListener: any;
  event: any;
  client: string;
  componentState: boolean = false;
  dataNew: any = [];

  constructor(public eventProvider: EventData, public params: NavParams, public navCtrl: NavController, events: Events) {
    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'news').subscribe(stateModule => {
      if (stateModule.$value === true) {
        this.componentState = true;
      } else {
        this.componentState = false;
      }
    });

    this.obs = new Observable(observer => {
      this.obsNew = this.eventProvider.getListNews(this.client, this.event.id).subscribe((data: any) => {
        if (data && this.componentState) {
          observer.next(data);
        } else {
          observer.next(false);
        }
      });
    });

    this.obs.subscribe((value) => {
      this.dataNew = [];

      if (this.obsRelatedNews) {
        this.obsRelatedNews.unsubscribe();
      }

      if (value) {
          let hash = {};
          value = value.filter(function (current) {
            let exists = !hash[current.id] || false;
            hash[current.id] = true;
            return exists;
          });

          value.forEach((oneNew: any, key) => {
            if (oneNew.state == true) {
              this.obsRelatedNews = this.eventProvider.getNew(this.client, oneNew.newId).subscribe((data: any) => {
                let tmp = data;
                tmp.state = oneNew.data;
                tmp.order = oneNew.order;
                this.dataNew.push(tmp)
              });
            }
          });
      } else {
        this.dataNew = [];
      }
    });

    // close de listener where logout user
    events.subscribe('client:logout', (r) => {
      // this.closeListener();
    });
  }

  isRedirectNew(newNote) {
    console.log(newNote)
    if (newNote.link) {
        window.open(
          newNote.link,
          '_blank'
        );
    }
  }
  closeListener() {
    if (this.obsListener) {
      console.log('Se eliminan los observables de news');
      this.obsListener.unsubscribe();
    }
    if (this.obsNew) {
      this.obsNew.unsubscribe();
    }
    if (this.obsNew) {
      this.obsNew.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }

}



// WEBPACK FOOTER //
// ./src/components/event-news/event-news.ts